<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Usuarios"   />

    <Users />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Users from "@/components/Pages/Configuration/Users/index.vue";

export default defineComponent({
  name: "UsersPage",
  components: {
    PageTitle,
    Users,
  },
});
</script>
